<template>
  <div :class="wrapperClass">
    <div class="card__block">
      {{ errorText }}
      &nbsp;
      <ElButton size="small" @click.native="dispatchClick">
        <i class="material-icons">
          refresh
        </i>
        {{ $t('RETRY') }}
      </ElButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardApiError',

  props: {
    wrapperClass: {
      type: String,
      default: 'card',
    },

    errorText: {
      type: String,
      default() {
        return this.$t('API_ERROR');
      },
    },
  },

  methods: {
    dispatchClick() {
      this.$emit('retry');
    },
  },
};
</script>
